export default function getDataLayer(gtmObject) {
  const publishedDateTimeStamp = new Date(gtmObject.publishedDate * 1000);
  const publishedDay = publishedDateTimeStamp.getDate();
  const publishedMonth = publishedDateTimeStamp.getMonth() + 1;
  const publishedYear = publishedDateTimeStamp.getFullYear();
  const publishedFormattedHour = publishedDateTimeStamp
    .toLocaleTimeString()
    .replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");

  const weekday = [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ][publishedDateTimeStamp.getDay()];
  const gtm_name =
    "noticias." +
    (gtmObject.gtm_name != undefined ? gtmObject.gtm_name : "gtm_name");

  return {
    event: "sendPageview",
    cd_paseId: "-2",
    cd_nsSite: gtmObject.nsSite,
    cd_adblock: "no",
    cd_nsListaTags: "",
    cd_name: gtm_name,
    cd_autorefresh: "-2",
    cd_anioPublicacion: publishedYear,
    cd_mesPublicacion: publishedMonth,
    cd_diaPublicacion: publishedDay,
    cd_horaPublicacion: publishedFormattedHour,
    cd_diaSemanaPublicacion: weekday,
    cd_tituloNota: document.title,
    cd_blockPW: "si",
    cd_hardLW: "no",
    cd_hardPW: "no",
    cd_notaId: gtmObject._id,
    cd_temperatura: "-2",
    cd_pwAudiencia: "-2",
    cd_sexo: "-2",
    cd_edad: "-2",
    cd_tipoPagina: gtmObject.page_type,
    cd_multimedia: "-2",
    cd_tipoSuscriptor: "-2",
    cd_tipoLector: "-2",
    cd_concursos: "-2",
    cd_referrer: "-2", //getRefererer()
    cd_pwCounter: "-2",
    cd_choque: "-2",
    cd_paseFlujo: "-2",
    cd_planSeleccionado: "-2",
    cd_infobipId: "-2",
    cd_urlMultimedia: document.URL,
    cd_durMultimedia: "-2",
    cd_userDataImportAudiencias: "-2",
    cd_errorCollect: "-2",
    cd_notaTipo: "default",
    cd_campania: "-2", //getCampain()
    cd_FP_user: "-2",
    cd_FP_hit: "-2",
    cd_notaShared: "-2",
  };
}
